export interface Platform {
  id: string;
  name: string;
  subtitle: string;
  desc: string;
  tags: string[];
  icon: string;
  badge: string;
  color: string;
}

export const platforms: Platform[] = [
  {
    id: 'p1',
    name: 'NAVER Webtoon',
    subtitle: '韩国主流漫画平台',
    desc: '韩国国民级漫画平台，海量连载正版韩漫首发地，官方授权同步更新，画质与翻译都有保障。',
    tags: ['正版授权', '同步更新', '免费试读'],
    icon: 'ri-book-open-line',
    badge: '官方首发',
    color: 'bg-primary-500',
  },
  {
    id: 'p2',
    name: 'Kakao Webtoon',
    subtitle: 'Kakao 旗下漫画平台',
    desc: '依托 Kakao 生态的正版韩漫平台，特色付费阅读与优质独家内容，作者收益有保障。',
    tags: ['独家内容', '付费阅读', '优质翻译'],
    icon: 'ri-community-line',
    badge: '正版授权',
    color: 'bg-secondary-500',
  },
  {
    id: 'p3',
    name: '咚漫',
    subtitle: 'Kakao 中国官方漫画',
    desc: 'Kakao 面向中文读者推出的官方漫画平台，正版韩漫中文授权，下载 APP 即可畅读。',
    tags: ['中文正版', '官方 APP', '每日更新'],
    icon: 'ri-apps-2-line',
    badge: '中文正版',
    color: 'bg-accent-500',
  },
  {
    id: 'p4',
    name: 'Lezhin Comics',
    subtitle: '韩漫特色创作平台',
    desc: '以独特创作氛围闻名的韩漫平台，云集众多人气作者与高口碑作品，题材丰富多元。',
    tags: ['人气作者', '题材多元', '官方渠道'],
    icon: 'ri-palette-line',
    badge: '官方渠道',
    color: 'bg-foreground-800',
  },
  {
    id: 'p5',
    name: '腾讯动漫',
    subtitle: '国内正版引进渠道',
    desc: '国内漫画平台，引进众多正版韩漫作品，以本土化运营和便捷阅读体验见长。',
    tags: ['本土运营', '便捷阅读', '正版引进'],
    icon: 'ri-verified-badge-line',
    badge: '国内正版',
    color: 'bg-primary-600',
  },
  {
    id: 'p6',
    name: '哔哩哔哩漫画',
    subtitle: 'B站 漫画正版频道',
    desc: '哔哩哔哩旗下正版漫画平台，收录多部人气韩漫，弹幕氛围与社区互动丰富。',
    tags: ['社区互动', '正版收录', '多端同步'],
    icon: 'ri-bilibili-line',
    badge: '正版收录',
    color: 'bg-secondary-600',
  },
];